import React, { useState, useEffect, Fragment } from 'react'

import { Icon, Search as SearchIcon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import { useSearch } from 'Pods/UnifiedNavigation/Hooks/useSearch'

import ImageSearch from './Components/ImageSearch/ImageSearch'
import SuggestionRow from './Components/SuggestionRow/SuggestionRow'

function Search({
  isInListingPage,
  searchInputValue = '',
  searchPlaceholder,
  locale = 'en',
}) {
  const {
    query,
    wrapperRef,
    suggestions,
    showSuggestions,
    onInputChange,
    handleKeyDown,
    submitting,
    handleSubmit,
    cursorPosition,
  } = useSearch(isInListingPage, searchInputValue)
  const [isOpen, setIsOpen] = useState(false)
  // Below 390px the design shows a short "Search" placeholder; CSS cannot swap
  // placeholder text, so track the breakpoint and switch it in place.
  const [isCompact, setIsCompact] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 389px)')
    const handleChange = () => setIsCompact(mediaQuery.matches)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)

    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  function handleToggle() {
    setIsOpen(open => !open)
  }

  return (
    <Fragment>
      <button
        type="button"
        className={classnames('unified-nav__search-toggle', isOpen && 'unified-nav__search-toggle--active')}
        aria-label="Search"
        aria-expanded={isOpen}
        onClick={handleToggle}
      >
        <Icon notSpaced svgComponent={SearchIcon} color="darker" />
      </button>

      <div
        className={classnames('unified-nav__search', isOpen && 'unified-nav__search--open')}
        ref={wrapperRef}
      >
        <form
          className="unified-nav__search-form"
          id="nav-search-form"
          acceptCharset="UTF-8"
          action="/search"
          method="get"
          onSubmit={handleSubmit}
        >
          <div className="unified-nav__field">
            <input
              type="text"
              name="keywords"
              className="unified-nav__field-input cgt-body-base"
              placeholder={isCompact ? 'Search' : searchPlaceholder}
              autoComplete="off"
              value={query}
              onChange={onInputChange}
              onKeyDown={handleKeyDown}
            />
            <ImageSearch locale={locale} />
            <button
              type="submit"
              className="unified-nav__field-submit"
              aria-label="Search"
            >
              {submitting ? (
                <span className="unified-nav__field-spinner" />
              ) : (
                <Icon notSpaced svgComponent={SearchIcon} size="small" color="light" />
              )}
            </button>
          </div>
        </form>

        {suggestions.length > 0 && showSuggestions && (
          <div className="unified-nav__suggestions">
            <ul className="unified-nav__suggestions-list">
              {suggestions.map((resultRow, i) => (
                <li key={resultRow[0]}>
                  <SuggestionRow
                    query={query}
                    result={resultRow[0]}
                    thumbnailUrl={resultRow[1].thumbnailUrl}
                    className={i === cursorPosition ? 'is-active' : ''}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Fragment>
  )
}

Search.propTypes = {
  isInListingPage: bool.isRequired,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
  locale: string,
}

export default Search
